import { useCallback, useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from '@remix-run/react'
import ReactPaginate, { type ReactPaginateProps } from 'react-paginate'

type PaginateProps = Omit<ReactPaginateProps, 'pageCount'> & {
  itemsTotal: number
  itemsPerPage: number
  onPaginate?: (pageNo: number) => void
}

// required cause in the server is causing issues.
let isHydrating = true

const CIOPaginate = ({
  itemsTotal,
  itemsPerPage,
  onPaginate,
  ...props
}: PaginateProps): JSX.Element => {
  // required cause in the server is causing issues.
  const [isHydrated, setIsHydrated] = useState(!isHydrating)

  const [searchParams] = useSearchParams()
  const currentPage = searchParams.get('page') || '1'
  const totalPages = Math.ceil(itemsTotal / itemsPerPage)
  const navigate = useNavigate()
  const handleClick = useCallback<NonNullable<ReactPaginateProps['onClick']>>(
    (clickEvent) => {
      navigate(`?page=${(clickEvent.nextSelectedPage || 0) + 1}`)

      if (onPaginate) {
        onPaginate((clickEvent.nextSelectedPage || 0) + 1)
      }
    },
    [navigate, onPaginate],
  )

  // required cause in the server is causing issues.
  useEffect(() => {
    isHydrating = false
    setIsHydrated(true)
  }, [])

  return (
    <div className="flex items-center justify-between">
      <div className="hidden text-neutral-100 whitespace-nowrap text-s max-md:block">
        Page {currentPage}/{totalPages}
      </div>

      {isHydrated && (
        <ReactPaginate
          {...props}
          activeClassName="active"
          className="text-s flex items-center overflow-hidden list-none text-neutral-100 w-full p-0 m-0 max-md:w-auto paginator"
          pageCount={totalPages}
          forcePage={Number(currentPage) - 1}
          hrefBuilder={(page, pageCount) =>
            page >= 1 && page <= pageCount ? `?page=${page}` : '#'
          }
          onClick={handleClick}
        />
      )}
    </div>
  )
}

export default CIOPaginate
